<h1 mat-dialog-title>Delete Contract Template</h1>

<div mat-dialog-content>
    Are you sure you want to delete this template?
</div>

<div mat-dialog-actions class="float-right">
    <button mat-stroked-button [mat-dialog-close]="false">No</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
</div>